import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataCustomDocument } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import useStore from '../../hooks/use-store';
import BaseNode from '../base-node';
import DrawerContent from './drawer-content';
export const CustomDocumentNode = node => {
  const $ = _c(7);
  const {
    data: t0
  } = useStore();
  const {
    canEdit
  } = t0;
  let t1;
  if ($[0] !== canEdit || $[1] !== node) {
    t1 = {
      form: "custom-document",
      size: "lg",
      render: t2 => {
        const {
          mutation,
          isFirmEmployee
        } = t2;
        return <DrawerContent node={node} mutation={mutation} canEdit={canEdit} isFirmEmployee={isFirmEmployee} />;
      }
    };
    $[0] = canEdit;
    $[1] = node;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== t1) {
    t2 = <BaseNode nodeId={node.id} data={node.data} sidebar={t1} />;
    $[3] = node.data;
    $[4] = node.id;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};